import {sprintf} from 'sprintf-js';
import languageMap from './locale/en';

export default function (key, field, properties = {}) {
    const fieldKey = `${key}-${field}`;
    const param = properties[key];
    const value = sprintf(languageMap[fieldKey], param) || sprintf(languageMap[key], param);

    if (!value) {
        console.error(`Cannot find text for <${fieldKey}> or <${key}> key`);
    }
    return value;
}



// WEBPACK FOOTER //
// ./src/sources/localizeServerError.js